import type {
  ObjectToolbarConfig,
  RegisterToolbarConfigArgs,
} from '@/blocks/object-toolbar';

/**
 * Assemble the object-toolbar config for the Control Groups register/list page
 * (CUS-153 sweep). Register toolbars are type-level: no `parentObject`
 * (permissions resolve against the type) and no `save` (a list page has no
 * form). Unlike the Controls/Indicators registers, control-groups has no
 * `CustomisableRibbon`, so there is no ribbon-edit overflow group — but it does
 * carry a primary "Add" action the other registers lack, gated on
 * `insert:control_group` (matching the legacy register `<Permission>`).
 *
 * Takes the shared {@link RegisterToolbarConfigArgs} (see
 * `blocks/object-toolbar/types.ts`) — the input shape every module's register
 * builder uses across the CUS-136 fanout. Pure so it can be unit-tested without
 * rendering the page.
 */
export const buildControlGroupRegisterToolbarConfig = ({
  title,
  counter,
  exportOptions,
  create,
}: RegisterToolbarConfigArgs): ObjectToolbarConfig => ({
  header: { title, counter },
  actions: {
    ...(create
      ? {
          primary: [
            {
              id: 'create',
              label: create.label,
              iconName: 'plus',
              onClick: create.onClick,
              permission: 'insert:control_group',
              canHaveAccessAsContributor: true,
            },
          ],
        }
      : {}),
    export: [
      {
        id: 'export',
        actions: exportOptions.map((option) => ({
          id: option.id,
          label: option.text,
          iconName: 'download-01',
          onClick: option.exportFunction,
          disabled: option.disabled,
        })),
      },
    ],
  },
});
